import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  STORE_STATUS_INITIALIZED,
  STORE_SINGLE_PLAYER,
  STORE_SINGLE_PLAYER_BOLETO_BLOB,
} from 'constants/store'
import {
  createGenericSlice,
  createReducers,
  ExtraReducers,
  GenericState,
} from 'stores/generics'
import { Payload } from 'stores'
import { ErrorStore } from '@types'

export interface SinglePlayerBoletoState {
  boleto_blob: string
  original_amount_cents: number
  file: File | undefined
}

type State = GenericState<SinglePlayerBoletoState>

export const initialState: State = {
  data: {
    boleto_blob: '',
    original_amount_cents: 0,
    file: undefined,
  },
  status: STORE_STATUS_INITIALIZED,
  error: null,
}

export const setSinglePlayerBoleto = createAsyncThunk<
  SinglePlayerBoletoState,
  Promise<SinglePlayerBoletoState>,
  Payload
>(
  STORE_SINGLE_PLAYER_BOLETO_BLOB,
  async (promise: Promise<SinglePlayerBoletoState>, { rejectWithValue }) => {
    try {
      const response = await promise

      return response
    } catch (e: unknown) {
      const { code, message } = e as ErrorStore
      return rejectWithValue({ code, message })
    }
  }
)

const extraReducers: ExtraReducers = createReducers<
  SinglePlayerBoletoState,
  SinglePlayerBoletoState,
  Payload
>(setSinglePlayerBoleto, initialState.data)

const singlePlayerSlice = createGenericSlice({
  name: STORE_SINGLE_PLAYER,
  initialState,
  reducers: {},
  extraReducers,
})

const { actions, reducer } = singlePlayerSlice

const { clear } = actions

export { clear }

export default reducer
